export default __webpack_public_path__ + "839729ac38550508e4ca8aa4b9b78bae.png";